module.exports = __webpack_public_path__ + "img/second_home.128e47ce.svg";